import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { blastKeys, templateKeys } from './queryKeys';
import useQueryRequestParams from '../../../hooks/useQueryRequestParams';
import { extractBlastErrorCode } from '../pages/Blasts/blastFormUtils';
import markUrl from './markUrl';
const useUpdateBlast = () => {
    const additional = useQueryRequestParams();
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (body) => axios.post(markUrl('blasts/update/'), body, additional),
        onSuccess: (response) => {
            const id = response.data.blast_id;
            queryClient.setQueryData(blastKeys.detail(id), response);
            queryClient.invalidateQueries({ queryKey: blastKeys.validate(id) });
            queryClient.invalidateQueries({ queryKey: templateKeys.rows({ blast_id: id }) });
            return queryClient.invalidateQueries({ queryKey: blastKeys.list() });
        },
        onError: (error, request) => {
            // blast_not_* means the cached status is stale; refetch so the UI stops offering the action.
            if (extractBlastErrorCode(error)?.startsWith('blast_not_')) {
                queryClient.invalidateQueries({ queryKey: blastKeys.detail(request.blast_id) });
                queryClient.invalidateQueries({ queryKey: blastKeys.list() });
            }
        }
    });
};
export default useUpdateBlast;
